var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"88f640e13a50c3f6a27b066d6e5bcbecb455d6f8"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["outtaink@outtaink"]={id:"88f640e13a50c3f6a27b066d6e5bcbecb455d6f8"};
      